import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class MasbitHttpService {
  UNAUTHORIZED = 401;
  FORBIDDEN = 403;
  SERVER_ERROR = 500;
  retryCall = false;
  constructor(
      private http: HttpClient,

  ) { }


  public get<T>(url: string, params?: HttpParams): Observable<T> {
    const defaultHeaders = this.getDefaultHeaders();
    const headers = this.getAuthorizationHeader(defaultHeaders);
    return this.http.get<T>(url, { headers: headers, params: params, withCredentials : true });
  }

  public getFile<T>(url: string): Observable<T> {
    const headers = this.getAuthorizationHeader();
    return this.http.get<T>(url, { headers: headers, responseType : 'blob' as 'json', withCredentials : true});
  }

  public put<T>(url: string, data: T): Observable<any> {
    const defaultHeaders = this.getDefaultHeaders();
    const headers = this.getAuthorizationHeader(defaultHeaders);
    return this.http.put<T>(url, JSON.stringify(data), {headers: headers, withCredentials  : true});
  }

  delete<T>(url: string, params?: HttpParams): Observable<T> {
    this.retryCall = false;
    const defaultHeaders = this.getDefaultHeaders();
    const headers = this.getAuthorizationHeader(defaultHeaders);
    return this.http.delete<T>(url, { headers: headers, params: params, withCredentials :true });
  }

  deleteWithBody<T>(url: string, body: any) {
    this.retryCall = false;
    const defaultHeaders = this.getDefaultHeaders();
    const headers = this.getAuthorizationHeader(defaultHeaders);
    const httpOptions = {
      headers: headers,
      body: body,
      withCredentials : true
    };
    return this.http.delete<T>(url, httpOptions);
  }

  post<T>(url: string, body?: any, multipart? : boolean): Observable<T> {
    this.retryCall = false;
    const defaultHeaders = this.getDefaultHeaders(multipart);
    const headers = this.getAuthorizationHeader(defaultHeaders);
    return this.http.post<T>(url, body, { headers: headers, withCredentials : true });
  }

  private getAuthorizationHeader(httpHeaders?: HttpHeaders): HttpHeaders {
    let authData = JSON.parse(localStorage.getItem('auth_data'));
    if (httpHeaders) {
      if (authData && authData.token) {
        httpHeaders = httpHeaders.append('Authorization', `Bearer ${authData.token}`);
      }
      return httpHeaders;
    } else {
      if (authData && authData.token) {
        return new HttpHeaders().set('Authorization', `Bearer ${authData.token}`);
      }
    }
  }

  private handleError(error: any) {
    if (error && error.status === this.UNAUTHORIZED) {
      return this.authenticationErrorHandler();
    } else if (error && error.status === this.FORBIDDEN) {
      // this.userDataService.removeUserCookie();
      // } else if (error && error.status >= this.SERVER_ERROR) {
      //   this.router.navigate(['server-error']);
      return <any>Promise.reject(error);
    } else {
      return <any>Promise.reject(error);
    }
  }

  private authenticationErrorHandler() {
    // this.router.navigate(['server-error']);
  }

  private getDefaultHeaders(multipart ? : boolean) {
    let out = new HttpHeaders();
    if (multipart)
      out.set('Content-Type', 'application/json');
    else
      out.set('Content-Type', 'multipart/form-data');
    return out;
  }

}
